import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { EmbeddableCellData } from './EmbeddableCellData.js';
export const RenderCellInner = JSX(({ cell, fieldIdx, rowIdx, cellIdx, setTableInner, tableInner, openTableInnerIdx, setOpenTableInnerIdx, }) => {
    const [isVisible, setVisibility] = useState(true);
    useEffect(() => {
        if (cellIdx !== openTableInnerIdx || !tableInner) {
            setVisibility(true);
        }
    }, [tableInner, openTableInnerIdx]);
    const displayTable = (props) => {
        setVisibility(false);
        setOpenTableInnerIdx(cellIdx);
        setTableInner(props);
    };
    return renderCell({
        cell,
        cellProps: {
            rowIdx,
            cellIdx,
            fieldIdx,
            displayTable,
            isVisible,
        },
    });
});
const renderCell = ({ cell, cellProps }) => {
    if (!cell) {
        return null;
    }
    const { tableCellType: type, ...rest } = cell;
    if (!type || !(type in EmbeddableCellData)) {
        return null;
    }
    const EmbeddableCellInner = EmbeddableCellData[type];
    return _jsx(EmbeddableCellInner, { ...cellProps, ...rest });
};
//# sourceMappingURL=TariffsTableRenderCell.js.map